import styled from 'styled-components';
import { Box } from '@kite-js/core';
import { registerSetViewHeight } from '@utils/registerSetViewHeight';

registerSetViewHeight();

export const FitViewPortBox = styled(Box)`
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);
    min-width: 100vw;
    & > * {
        min-height: inherit;
    }
`;
